module.exports = __webpack_public_path__ + "static/media/icone-exames-externos-branco.7fc0b64e.svg";